export const handleUserSelection = (currentValues: string[], newValues: string[], setFunc: (values: string[]) => void): void => {
    // if the user selects 'all', it should deselect all other options
    // If the new values include 'all', or if the list is empty (meaning all items were deselected), we should set the newValues state to ['all'].
    if (!currentValues.includes('all') && newValues.includes('all')) {
      setFunc(['all']);
    } else {
      if (newValues.length === 0) setFunc(['all']);
      else setFunc(newValues.filter((v: string) => v !== 'all'));
    }
};